import { styled, type SxProps } from '@mui/material'

const styles: {
  [key: string]: SxProps
} = {
  wrapper: {
    minWidth: {
      xs: '100%',
      sm: 'unset',
    },
    overflow: 'hidden',
    // Calendly widget custom styling to match project theme
    '& .booking-kit_confirm-button-selected_87095647': {
      backgroundColor: '#4540D5 !important',
    },
    '& .booking-kit_confirm-button_87095647': {
      backgroundColor: '#4540D5 !important',
      borderColor: '#4540D5 !important',
    },
    '& .booking-kit_confirm-button_87095647:hover': {
      backgroundColor: '#2D2AA9 !important',
      borderColor: '#2D2AA9 !important',
    },
    '& .booking-kit_confirm-button_87095647:focus': {
      backgroundColor: '#4540D5 !important',
      borderColor: '#4540D5 !important',
      boxShadow: '0 0 0 3px rgba(69, 64, 213, 0.2) !important',
    },
    // Style the time slot buttons
    '& .booking-kit_time-slot-button_87095647': {
      borderColor: '#D1D1D1 !important',
      color: '#2A2E3C !important',
    },
    '& .booking-kit_time-slot-button_87095647:hover': {
      borderColor: '#4540D5 !important',
      backgroundColor: '#F0F5FF !important',
    },
    '& .booking-kit_time-slot-button_87095647[data-selected="true"]': {
      backgroundColor: '#4540D5 !important',
      borderColor: '#4540D5 !important',
      color: '#FFFFFF !important',
    },
    // Style the back button
    '& .booking-kit_back-button_87095647': {
      color: '#4540D5 !important',
    },
    '& .booking-kit_back-button_87095647:hover': {
      backgroundColor: '#F0F5FF !important',
    },
    // Style the calendar navigation
    '& .booking-kit_calendar-nav-button_87095647': {
      color: '#4540D5 !important',
    },
    '& .booking-kit_calendar-nav-button_87095647:hover': {
      backgroundColor: '#F0F5FF !important',
    },
    // Style the month/year text
    '& .booking-kit_calendar-month_87095647': {
      color: '#2A2E3C !important',
    },
    // Style the day names
    '& .booking-kit_calendar-day-name_87095647': {
      color: '#5D5D5D !important',
    },
    // Style the date numbers
    '& .booking-kit_calendar-date_87095647': {
      color: '#2A2E3C !important',
    },
    '& .booking-kit_calendar-date_87095647:hover': {
      backgroundColor: '#F0F5FF !important',
      color: '#4540D5 !important',
    },
    '& .booking-kit_calendar-date_87095647[data-selected="true"]': {
      backgroundColor: '#4540D5 !important',
      color: '#FFFFFF !important',
    },
    // Style the time zone selector
    '& .booking-kit_timezone-select_87095647': {
      color: '#2A2E3C !important',
    },
    // Style the duration text
    '& .booking-kit_duration-text_87095647': {
      color: '#5D5D5D !important',
    },
  },
  iframeWrapperSx1: {
    borderRadius: '12px',
    margin: '-65px  15px 50px 15px',
    boxShadow: ' 0 4px 25px 0 rgba(0, 0, 0, 0.18)',
  },
  iframeWrapperSx2: {
    margin: '-130px 0 0 0',
  },
}

export const IFrameWrapper = styled(
  'div',
  {}
)(({ theme }) => ({
  margin: '-65px  15px 50px 15px',
  boxShadow: '0 4px 20px rgba(69, 64, 213, 0.15)',
  marginTop: '0.8rem',
  border: `1px solid ${theme.palette.border.light}`,
  borderBottom: `1px solid ${theme.palette.border.light}`,
  borderRadius: '12px',
  // maxHeight: 'auto',
  width: '400px',
  maxWidth: '100%',
  position: 'relative',
  backgroundColor: '#F6F6F6',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: `1px solid ${theme.palette.border.light}`,
    borderBottom: `2px solid ${theme.palette.border.light}`,
    borderRadius: '12px',
    pointerEvents: 'none',
    zIndex: 1,
  },
  '& iframe': {
    borderRadius: '12px !important',
    backgroundColor: '#F6F6F6 !important',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    margin: 'unset',
  },
}))

export default styles
